import { useMatches } from '@tanstack/react-router';

import { useTourOptional } from './tour-context';
import type { TourDefinition } from './types';

/**
 * Tours the deepest matched route declares in `staticData.tours`, limited to those this person
 * can take. Empty outside a TourProvider or on routes without tours.
 */
export function useRouteTours(): TourDefinition[] {
  const tour = useTourOptional();
  const matches = useMatches();
  if (!tour?.enabled) return [];
  for (let i = matches.length - 1; i >= 0; i -= 1) {
    const ids = matches[i]?.staticData.tours;
    if (ids && ids.length > 0) {
      return ids.flatMap((id) => {
        const definition = tour.registry.get(id);
        return definition && tour.isAvailable(definition) ? [definition] : [];
      });
    }
  }
  return [];
}
